import { Button, dialog } from "../../../nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { exportCSVUseCase } from "../../../usecases/csv/usecases";
import { Progress, InfiniteScroll } from "../../../nq-component";
import withRouter from "../../../withRouter";

import BaseListPage from "../../../base/BaseListPage";
import NavBar from "../../../components/navbar";
import InputFactory from "../../../components/InputFactory";

import Table from "../../../components/Table";

import QueueingListPresenter from "./QueueingListPresenter";
import DialogConfirmation from "../components/DialogConfirmation";
import DialogSuccess from "../components/DialogSuccess";
import DialogWarning from "../components/DialogWarning";
import excludedFields from "./excludedFields";

class QueueingListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new QueueingListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      loading: false,
      total: 0,
      count: 0,
      showDetails: false,
      empDetails: {},
      formData: {
        requestType: "",
        remarks: "",
        attachment: "",
      },
    };
  }

  getCollectionName() {
    return "queue";
  }

  componentWillUnmount() {
    if (this.presenter) {
      this.presenter.stopPolling();
    }
  }

  onClickServe(index) {
    console.log("iii", index);
    const object = this.state.objects[index];
    console.log("o", object);
    this.presenter.onClickServe(object);
  }

  onCollapse(index) {
    return (
      <div>
        <button
          className="btn text-white"
          style={{ backgroundColor: "#D18237" }}
          onClick={() => this.onClickServe(index)}
        >
          Serve
        </button>
      </div>
    );
  }

  showNote(title, message) {
    dialog.close();
    dialog.fire({
      html: <DialogWarning title={title} message={message} />,
      footer: false,
    });
  }
  showSuccess(message) {
    dialog.close();
    dialog.fire({
      html: <DialogSuccess message={message} />,
      footer: false,
    });
  }

  onReset() {
    this.presenter.onReset();
  }

  onClickReset() {
    dialog.fire({
      html: <DialogConfirmation handleAssign={this.onReset.bind(this)} />,
      footer: false,
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, selected, count, progress, empDetails } = this.state;
    console.log("ASAS", objects);
    if (!schema) return <Progress />;
    const user = this.getCurrentUser();
    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1 className="fw-bold text-capitalize">
                  {schema.label || this.getCollectionName()}
                </h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>
              <div className="d-flex mt-3">
                {Object.keys(schema.filters || {}).map((field) => {
                  let { type, ...options } = schema.filters[field];
                  return (
                    <InputFactory
                      key={field}
                      className="ms-1"
                      type={type}
                      field={field}
                      where={{}}
                      onChange={this.onChangeFilter.bind(this, type)}
                      {...options}
                    />
                  );
                })}
              </div>
              <div className="d-flex justify-content-end">
                <button
                  className="btn text-white"
                  style={{ backgroundColor: "#e09552" }}
                  onClick={this.onClickReset.bind(this)}
                >
                  <i class="bi bi-arrow-clockwise"></i>
                  {""}
                  Reset
                </button>
              </div>
              <div className="d-flex ">
                <div className=" w-100">
                  <Table
                    fields={schema.fields}
                    // onClick={this.clickData.bind(this)}
                    objects={objects}
                    // selectable
                    collapsable
                    excludeFields={Object.keys(schema.fields).reduce(
                      (acc, key) => {
                        const options = schema.fields[key];

                        excludedFields.map((field) => {
                          acc.push(field);
                        });
                        if (options.read === false) {
                          acc.push(key);
                        }
                        switch (options._type || options.type) {
                          case "Relation":
                          case "Array":
                          case "Object":
                          case "File":
                            acc.push(key);
                            break;
                          default:
                        }
                        return acc;
                      },
                      [
                        "acl",
                        "password",
                        "id",
                        "updated",
                        "employeeId",
                        "recruiterFirstName",
                        "recruiterMiddleName",
                        "recruiterLastName",
                      ]
                    )}
                    selected={selected}
                    onSelect={this.onSelect.bind(this)}
                    onSelectAll={this.onSelectAll.bind(this)}
                    progress={progress}
                    onClickItem={this.onClickItem.bind(this)}
                    onCollapse={this.onCollapse.bind(this)}
                    onSort={this.onClickSort.bind(this)}
                    className="mt-1"
                    numbering={true}
                  />
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>
        {user.roles[0].id === "Admin" && (
          <div className="position-fixed bottom-0 end-0 m-4">
            <Button
              className="btn shadow-sm text-white"
              onClick={this.onClickAdd.bind(this)}
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "25px",
                backgroundColor: "#e09552",
              }}
            >
              <i className="bi bi-plus-lg" />
            </Button>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(QueueingListPage);
